import { Box, Container, Heading, useToast } from '@chakra-ui/react'
import { ErrorBoundary } from 'react-error-boundary'
import { FilterBar } from './components/FilterBar'
import { AgendamentosList } from './components/AgendamentosList'
import { useMensagensAgendadas } from './hooks/useMensagensAgendadas'
import { ErrorFallback } from './components/ErrorFallback'

export const MensagensAgendadas = () => {
  const toast = useToast()

  const {
    agendamentos,
    filtros,
    isLoading,
    paginacao,
    register,
    handleSubmit,
    handleChangePaginacao,
    handleChangeLimite,
    handleLimparFiltros,
    isError,
    toggleOrdenacao,
  } = useMensagensAgendadas(toast)

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Container maxW="1366px" px={4} py={5} >
        <Box mb={6} display="flex" justifyContent="space-between" alignItems="center">
          <Heading size="lg">Mensagens Agendadas</Heading>
        </Box>

        <FilterBar
          isLoading={isLoading}
          onLimpar={handleLimparFiltros}
          register={register}
          handleSubmit={handleSubmit}
        />

        <AgendamentosList
          agendamentos={agendamentos}
          isLoading={isLoading}
          paginacao={paginacao}
          onChangePaginacao={handleChangePaginacao}
          onChangeLimite={handleChangeLimite}
          isError={isError}
          filtros={filtros}
          toggleOrdenacao={toggleOrdenacao}
        />
      </Container>
    </ErrorBoundary>
  )
}